import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { FinegrainRolesService } from '../../common/services/finegrain-roles/finegrain-roles.service';
import { SideNavService } from '../services/sidenav-service/sidenav.service';
import { MatSidenavContainer, MatSidenav as MatSidenav_1 } from '@angular/material/sidenav';
import { NgIf } from '@angular/common';
import { UserRoleGetFormComponent } from '../user-role-form/user-role-get-form/user-role-get-form.component';
import { UserRoleSideNavComponent } from '../user-role-side-nav/user-role-side-nav.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-user-role-main',
    templateUrl: './user-role-main.component.html',
    styleUrls: ['./user-role-main.component.scss'],
    imports: [MatSidenavContainer, NgIf, UserRoleGetFormComponent, MatSidenav_1, UserRoleSideNavComponent, TranslatePipe]
})
export class UserRoleMainComponent implements OnInit, AfterViewInit {
  @ViewChild('sidenav', { static: false }) sidenav: MatSidenav;
  constructor(private sidenavService: SideNavService, private fineGrainService: FinegrainRolesService) {
  }
  /**
  * Property deletmine is role manager authorized
  **/
  public get isAuthorizedMngr(): boolean {
    return this.fineGrainService.getPortalPermissions('user_role');
  }

  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
  }
  /**
   * @function ngAfterViewInit Called after the view is initialized
   */
  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }
}
